import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { IsTrustedPartnerContextProvider } from '@modules-deprecated/app/umbrellas'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { EditSubscriptionParams } from '@views/settings/routes/OrganizationSubscriptionSettings/types'
import { SubscriptionTrialExpired } from '@views/subscriptionTrialExpired'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberEventFn } from '../../types/emberEventFn'
import { HistoryRouter } from '../../utils/HistoryRouter'

class LockedWebComponent extends DOMModel {
  @byAttrVal organizationid: string
  @registerEvent('editSubscription') editSubscription: EmberEventFn
}

type LockedProps = {
  organizationid: string
  onEditSubscription: (detail: EditSubscriptionParams) => void
}

function LockedModule({ onEditSubscription, organizationid }: LockedProps): ReactElement {
  return (
    <ThemeProvider>
      <HistoryRouter>
        <QueryClientProvider client={queryClient}>
          <UserOrganizationSettingsContextProvider organizationId={organizationid}>
            <UserOrganizationContextProvider organizationId={organizationid}>
              <IsTrustedPartnerContextProvider organizationId={organizationid}>
                <CurrentUserContextProvider>
                  <ModalContextProvider>
                    <SubscriptionTrialExpired organizationId={organizationid} onEditSubscription={onEditSubscription} />
                  </ModalContextProvider>
                </CurrentUserContextProvider>
              </IsTrustedPartnerContextProvider>
            </UserOrganizationContextProvider>
          </UserOrganizationSettingsContextProvider>
        </QueryClientProvider>
      </HistoryRouter>
    </ThemeProvider>
  )
}

const LockedCustomElement = createCustomElement(LockedModule, LockedWebComponent, 'element')

customElements.get('locked-module') || customElements.define('locked-module', LockedCustomElement)

export default LockedCustomElement
